import React, {
  useState,
  useMemo,
  createContext,
  ReactNode,
  useEffect,
} from "react";
// @ts-ignore
import CryptoJS from "crypto-js";
import { useSearchParams } from "react-router-dom";
import { PayDataType, RoutingContextType } from "./types";

export const pagesMapping = {
  methods: "methods",
  mono: "mono",
  baepay: "baepay",
  kuda: "kuda",
  stitch: "stitch",
  transfer: "transfer",
  card: "card",
  wallet: "wallet",
  mpesa: "mpesa",
  cellulant: "cellulant",
  ussd: "ussd",
};

export const RoutingContext = createContext<RoutingContextType>({
  merchantKey: "",
  email: "test@klasha.com",
  currency: "NGN",
  amount: 1,
  payData: { kit: { sourceAmount: "", fullname: "", tx_ref: "", paymentType: "" } },
});

const Router = ({ children }: { children: ReactNode }) => {
  const [amount, setAmount] = useState<string>("");
  const [currency, setCurrency] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [merchantKey, setMerchantKey] = useState<string>("");
  const [payData, setPayData] = useState<PayDataType>({
    kit: { sourceAmount: "", fullname: "", tx_ref: "" },
  });

  const [searchParams] = useSearchParams();

  const encryptedRouteDetails = searchParams.get("details");
  const storedRoute = localStorage.getItem("route");

  const getPaymentDetails = (encryptedData: string) => {
    const decodeBase64 = window.atob(encryptedData);

    const decryptedBytes = CryptoJS.AES.decrypt(
      decodeBase64,
      "AanwanQJgwof2ZR5vUnhHEt2FpMMDJ6lpClGuRWzEpc="
    );
    const decryptedData = JSON.parse(
      decryptedBytes.toString(CryptoJS.enc.Utf8)
    );
    const {
      currency: resCurrency,
      email: resEmail,
      amount: resAmount,
      merchantKey: resMerchantKey,
    } = decryptedData;
    setEmail(resEmail);
    setAmount(resAmount);
    setCurrency(resCurrency);
    setMerchantKey(resMerchantKey);
    setPayData(decryptedData);
  };

  useEffect(() => {
    if (storedRoute) {
      getPaymentDetails(storedRoute);
    }
  }, []);

  useEffect(() => {
    if (encryptedRouteDetails && searchParams.has("details")) {
      localStorage.setItem("route", encryptedRouteDetails);
      getPaymentDetails(encryptedRouteDetails);
    }
  }, [encryptedRouteDetails, searchParams]);

  const value = useMemo(
    () => ({ email, currency, amount, merchantKey, payData }),
    [amount]
  );

  return (
    <RoutingContext.Provider value={value}>{children}</RoutingContext.Provider>
  );
};

export default Router;
